import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const contentWrapper = css`
  height: 100%;
  width: 100%;
  padding: 25px 30px;
`;

export const mediaTypeSelectionSection = css`
  margin-top: 40px;
  width: 100%;
  display: flex;
  justify-content: space-around;
`;

export const headerIconLine = css`
  display: flex;
  gap: 5px;
  margin-bottom: 10px;

  > svg {
    color: ${colors.primary.default};
    width: ${icons.size.small};
    height: ${icons.size.small};
  }
`;

export const videoBox = css`
  width: 320px;
`;

export const optionBox = css`
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const block = css`
  border: 1px solid ${colors.gray.light};
  border-radius: 5px;
  padding: 20px;
  height: 265px;
  width: 360px;
  cursor: pointer;

  .boxHeaderButton {
    color: ${colors.primary.default};
    white-space: nowrap;
    height: 30px;
    min-width: 30px;
    padding: 0;
    > span > span:first-child {
      margin: 0;
    }
    > span > span:last-child {
      display: none;
    }
  }

  :hover {
    background-color: rgba(23, 116, 240, 0.03);
    transform: scale(1.01);
    transition: transform 0.1s;
    border: 1px solid ${colors.primary.default};

    .boxHeaderButton {
      background-color: inherit;
      min-width: 150px;
      padding: 0 20px;
      > span > span:first-child {
        margin: 10px;
      }
      > span > span:last-child {
        display: inline-block;
      }
    }
  }
`;
